import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-full flex flex-col px-12px py-12px"
}
const _hoisted_2 = { class: "w-full flex justify-between items-center" }
const _hoisted_3 = { class: "plus cursor-pointer flex items-center gap-[5px] h-[32px] bg-[#f5f7fa] rounded-[4px] text-[14px] font-400 text-[#38393b] px-12px" }
const _hoisted_4 = { class: "search flex items-center mt-12px w-full" }
const _hoisted_5 = {
  key: 0,
  class: "w-full font-bold mt-12px mb-[12px]"
}
const _hoisted_6 = { class: "folderList flex flex-wrap gap-[10px] justify-start w-full" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "font-400 mt-[4px] w-full overflow-hidden text-ellipsis whitespace-nowrap text-[12px] text-center" }
const _hoisted_9 = {
  class: "filter flex items-center mt-12px w-full h-40px",
  style: {"justify-content":"space-between","border-bottom":"1px solid rgb(230, 230, 230)"}
}
const _hoisted_10 = { class: "tab flex items-center gap-[10px]" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex-1 min-h-0 overflow-auto" }
const _hoisted_13 = { class: "h-full" }
const _hoisted_14 = { class: "h-full py-[12px]" }
const _hoisted_15 = {
  key: 1,
  class: "px-[12px] w-full cursor-pointer"
}
const _hoisted_16 = { class: "w-full h-[10px] bg-[#f5f7fa] rounded-[5px] overflow-hidden mb-[12px]" }
const _hoisted_17 = { class: "text-[12px] text-[#666]" }
const _hoisted_18 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center"
}
const _hoisted_19 = { class: "text-center" }

import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElSlider } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted } from 'vue'
import { createFolder, getFolderList, getResourceCapacity } from '@/api/affairs'
import { resourcerFileUpload } from '@/api/design/resource'
//@ts-ignore
import myUpload from './myUpload.vue'
// @ts-ignore
import templatepage from './template.vue'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'user',
  setup(__props) {

const userStore = useUserStore()
const islogin = userStore.isLoggedIn
const keywords = ref('')
const tabs = [
  { name: 'work' as const, label: '作品' },
  { name: 'myUpload' as const, label: '我上传的' }
]
const activeTab = ref('work')
const folderOpen = ref(false)

const folders = ref([])
const resourceCount = ref(0)
const filterOn = ref(false)
const folderOn = ref(false)
const folderActive = ref({})
const handleFolderClick = (item: any) => {
  folderOn.value = true
  folderActive.value = item
  getList()
}
const fileInput = ref<HTMLInputElement | null>(null)
const myUploadRef = ref<myUpload>()
const handleBackClick = () => {
  // folderActive
  let folders = {
    id: (folderActive.value as any)?.parent_folder_id || '',
    name: (folderActive.value as any)?.parent_name || ''
  }
  folderActive.value = folders
  getList()
}
const onPlusCommand = async (cmd: string) => {
  if (cmd === 'upload') {
    fileInput.value?.click()
    return
  }
  if (cmd === 'folder') {
    try {
      const { value } = await ElMessageBox.prompt('请输入文件夹名称', '创建文件夹', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
      if (value && String(value).trim()) {
        createFolder({ name: String(value).trim(), parent_folder_id: (folderActive.value as any)?.id || '' }).then(res => {
          if (res.data.code === 200) {
            ElMessage.success('文件夹已创建')
            getList()
          }
        })
      }
    } catch (_) { }
  }
}
const handleLogin = () => {
  ; (window as any).openGlobalLogin?.()
}
const remainingCapacity = ref(0)
onMounted(() => {
  if (!islogin) {
    return
  }
  getList()
  getCapacity()
})
const getCapacity = () => {
  getResourceCapacity({}).then(res => {
    if (res.data.code == 200) {
      let arr = res.data.data
      arr.prop = arr.used_capacity / arr.capacity
      remainingCapacity.value = arr
    }
  })
}
const getList = () => {
  getFolderList({ parent_folder_id: (folderActive.value as any)?.id || '' }).then(res => {
    if (res.data.code == 200) {
      folders.value = res.data.data
    }
  })
}
const onFileChange = async (e: Event) => {
  const files = (e.target as HTMLInputElement).files
  if (!files || files.length === 0) return
  // ElMessage.success(`已选择 ${files.length} 个文件`)
  //   ; (e.target as HTMLInputElement).value = ''
  console.log(files[0])

  const folder_id = (folderActive.value as any)?.id || ''
  const res = await resourcerFileUpload(files[0], folder_id)
  if (res.data.code === 200) {
    myUploadRef.value?.getList()
    getCapacity()
  }
}
const getResourceList = (data: any) => {

}

return (_ctx: any,_cache: any) => {
  return (_unref(islogin))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "panel-title",
            onClick: handleBackClick
          }, [
            (folderActive.value.id)
              ? (_openBlock(), _createBlock(_unref(ElIcon), {
                  key: 0,
                  class: "back-icon cursor-pointer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ArrowLeft))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(folderActive.value.name || '我的资源'), 1)
          ]),
          _createVNode(_unref(ElDropdown), {
            trigger: "click",
            onCommand: onPlusCommand
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_unref(ElDropdownMenu), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElDropdownItem), { command: "upload" }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("上传文件", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_unref(ElDropdownItem), { command: "folder" }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("创建文件夹", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(ElIcon), { size: "16px" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Plus))
                  ]),
                  _: 1
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-400" }, "添加", -1))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("input", {
          ref_key: "fileInput",
          ref: fileInput,
          type: "file",
          class: "hidden-input position-fixed top-0 left-0 w-[0px] h-[0px] opacity-0",
          accept: ".png,.jpg,.jpeg,.webp,.svg",
          onChange: onFileChange
        }, null, 544),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(ElInput), {
            modelValue: _ctx.searchValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
            placeholder: "请输入搜索内容",
            clearable: "",
            "prefix-icon": _unref(Search),
            class: "w-full"
          }, null, 8, ["modelValue", "prefix-icon"])
        ]),
        (folders.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, "文件夹"))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(folders.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "items px-[12px] py-[8px] w-[80px] bg-[#f5f7fa] rounded-[4px]",
              key: item,
              onClick: ($event: any) => (handleFolderClick(item))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("img", {
                class: "w-[50px] mx-auto rounded-[4px]",
                src: "https://shanyin-design.oss-cn-hangzhou.aliyuncs.com/shanyin-design/image/user/7_1764320312000_456ecf4d-7469-4154-bf90-b9e8ca39a9e9.png",
                alt: ""
              }, null, -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.name), 1)
            ], 8, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
              return _createElementVNode("div", {
                class: _normalizeClass(["tab-title cursor-pointer", { 'select-bg': activeTab.value == tab.name }]),
                key: tab.name,
                onClick: ($event: any) => (activeTab.value = tab.name)
              }, _toDisplayString(tab.label), 11, _hoisted_11)
            }), 64))
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "filter cursor-pointer flex items-center gap-[10px]" }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("div", _hoisted_13, [
            _createVNode(templatepage, {
              id: folderActive.value.id
            }, null, 8, ["id"])
          ], 512), [
            [_vShow, activeTab.value == 'work']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createVNode(myUpload, {
              id: folderActive.value.id,
              ref_key: "myUploadRef",
              ref: myUploadRef
            }, null, 8, ["id"])
          ], 512), [
            [_vShow, activeTab.value == 'myUpload']
          ])
        ]),
        (remainingCapacity.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "w-full h-[10px] bg-[#2a66ff] rounded-[5px]",
                  style: _normalizeStyle({ width: `${(remainingCapacity.value.used_capacity / remainingCapacity.value.capacity) * 100}%` })
                }, null, 4)
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(remainingCapacity.value.used_capacity) + "Mb/" + _toDisplayString((remainingCapacity.value.capacity /
        1024)) + "G ", 1)
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-[14px] text-[#666] mb-[8px]" }, "请先登录", -1)),
          _createVNode(_unref(ElButton), {
            type: "primary",
            style: {"background-color":"#2a66ff"},
            onClick: handleLogin
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode("登录/注册", -1)
            ]))]),
            _: 1
          })
        ])
      ]))
}
}

})